<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            @onShowForm="showForm = true"
            :disabled="disabled"
            :dense="dense"
            :multiple="multiple"
        />
        
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'SysSelectPaymentType',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
        showForm: false,
    }),
    computed: {
        ...mapState('auth', ['acesso'])
    },
    mounted(){
        
    },
    created() {
        this.getItems();
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        clearable: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        disabled: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        }
        
    },
    watch: {
        
        selected(val){
            this.$emit('update:model', val);
        },
        
        model(val){
            this.selected = val;
        },
    },
    methods: {
        ...mapActions('paymentExport', ['ActionFindPaymentExportType']),        
        
        async getItems() {

            this.loading = true;
            let payload = {
                find_columns: {
                    active: 1
                }
            }

            await this.ActionFindPaymentExportType(payload)
                    .then((res) => {
                        this.items = res.data.filter(i => i.active);
                        this.selected = this.model;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },
    },
    
}
</script>